var app = angular.module("leonardo");

var WorkOrderResolveDialog = function($scope, $rootScope, $q, $state, ngDialog, NoteService, AttachmentService,
                                      NotificationService, FormErrorsService, PermissionService, WorkOrderService,
                                      FilterService, WorkOrderCVService, AnalyticsService) {
  $scope.workOrder = $scope.ngDialogData.work_order;
  $scope.data = {};
  $scope.attachments = [];
  $scope.attachments_note = [];
  $scope.permissionService = PermissionService;
  $scope.workOrderService = WorkOrderService;
  $scope.workOrderCVService = WorkOrderCVService;

  if ($scope.workOrder) {
    $scope.data = {
      pms_extra_fields: {}
    };
    if ($scope.workOrder.pms_extra_fields) {
      angular.forEach(Object.keys($scope.workOrder.pms_extra_fields), function(key) {
        if (!['work_order', 'pms_platform'].includes(key) && !isNull($scope.workOrder.pms_extra_fields[key])){
          $scope.data.pms_extra_fields[key] = $scope.workOrder.pms_extra_fields[key].id || $scope.workOrder.pms_extra_fields[key];
        }
      });
    }
  }

  angular.forEach($scope.workOrder.attachments, function(attachment) {
    $scope.attachments.push(attachment);
  });

  $scope.showWorkOrderDetail = function(work_order) {
    AnalyticsService.track('Task opened', {
      context: 'work orders',
      destination: 'detail',
      entry_method: 'click',
      ...AnalyticsService.getTaskGroupProperties(work_order)});
    work_order.getTriggerData().then(function (result) {
      ngDialog.open({
        template: 'views/templates/dialog/work-order/detail.html',
        controller: 'WorkOrderDetailsDialog',
        data: {
          work_order: result,
        }
      });
    });
  };

  $scope.checkAttachments = function () {
    var error = false;
    const permissionUploadYardi = PermissionService.permissionAvailableAccount('permission_upload_work_order');
    const propertyYardiID = FilterService.currentProperty ? !isNull(FilterService.currentProperty.pms_external_id) : false;

    if (!permissionUploadYardi || !propertyYardiID) {
      return;
    }

    if ($scope.attachments_note) {
      angular.forEach($scope.attachments_note, function (attachment) {
        let name;
        if (attachment.file && attachment.file.name) {
          name = attachment.file.name;
        }
        else {
          name = attachment.file ? attachment.file : attachment.name;
        }
        const array_name = name.split('.');
        const extension = (array_name.length > 1) ? array_name[array_name.length - 1] : null;
        if (extension && !AttachmentService.validYardiFormats.includes(extension)) {
          error = true;
        }
      });
    }

    if (error){
      NotificationService.error('Warning! Yardi only supports the following file types: .jpg, .jpeg, .pdf <br><br> Any other attachment file type will not be synced');
    }
  };

  $scope.removeAttachmentNote = function(index) {
    $scope.attachments_note.splice(index, 1);
    $scope.checkAttachments();
  };

  $scope.showAttachNoteFileDialog = function() {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/attachment/upload.html',
      controller: 'AttachmentUploadDialog',
      data: {task: {}, mode: 'upload_note'}
    }).then(function(attachments) {
      angular.forEach(attachments, function(attachment) {
        $scope.attachments_note.push(attachment);
      });
      $scope.checkAttachments();
    });
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = angular.copy($scope.data);

    var promises = [];
    data['attachments'] = [];
    angular.forEach($scope.attachments, function(attachment) {
      data['attachments'].push(attachment);
    });

    var result = {
      pms_extra_fields: $scope.data.pms_extra_fields
    };

    if ($scope.attachments_note.length > 0) {
      data['text'] = '';

      var attachments_note = [];
      angular.forEach($scope.attachments_note, function(attachment) {
        if (attachment.document_folder || attachment.document_file) {
          promises.push(AttachmentService.linkTo(attachment).then(function (response) {
            attachments_note.push(response.data.id);
          }));
        }
        else if (attachment.link) {
          promises.push(AttachmentService.post(attachment.name, null, attachment.link, attachment.available_for_account).then(function(response){
            attachments_note.push(response.data.id);
          }));
        }
        else {
          promises.push(AttachmentService.post(attachment.name, attachment.file, null, attachment.available_for_account).then(function(response){
            attachments_note.push(response.data.id);
          }));
        }
      });
      $q.all(promises).then(function(){
        data['attachments'] = attachments_note;
        data['workorder_set'] = [];
        data['workorder_set'].push($scope.workOrder.id);
        NoteService.post(data).then(function() {
          $scope.workOrder.patch(result).then(function() {
            $rootScope.$broadcast('work-order:updated');
            $scope.closeThisDialog();
          });
        });
      });
    }
    else {
      $scope.workOrder.patch(result).then(function() {
        $rootScope.$broadcast('work-order:updated');
        $scope.closeThisDialog();
      });
    }
  };

};

app.controller('WorkOrderResolveDialog', ['$scope', '$rootScope', '$q', '$state', 'ngDialog', 'NoteService',
  'AttachmentService', 'NotificationService', 'FormErrorsService', 'PermissionService', 'WorkOrderService',
  'FilterService', 'WorkOrderCVService', 'AnalyticsService', WorkOrderResolveDialog]);
